export default "__VITE_ASSET__CFxQwcq1__"